<template>
  <CContainer class="pt-5" fluid>
    <CRow>
      <CCol class="col-7">
        <h3 class="pl-3 mb-0 pb-0">Paid Payment</h3>
        <b-breadcrumb class="my-0 pt-1" style="border-bottom: 0px">
          <b-breadcrumb-item active>
            <CIcon name="cil-credit-card" />
            Payment Fiducia
          </b-breadcrumb-item>
          <b-breadcrumb-item active>
            Paid
          </b-breadcrumb-item>
        </b-breadcrumb>
      </CCol>
    </CRow>
    <CCard class="custom-card">
      <CCardBody class="px-0 pb-0" v-if="$helper.isRole($availRoles['Cabang']) || $helper.isRole($availRoles['FIMS']) || $helper.isRole($availRoles['HO']) || $helper.isRole($availRoles['Notaris'])">
        <CRow>
          <CCol class="col-xs-12 col-sm-10 col-md-9 col-lg-8 col-xl-7 ml-5">
            <CForm>
              <b-input-group class="custom-input-group-white">
                <b-input-group-prepend class="custom-prepend-middle">
                  <!-- <multiselect 
                    :allow-empty="false"
                    v-model="filter.periodBy" 
                    :options="filter.periodOptions"
                    :searchable="false"
                    id="period-table"
                    placeholder="Select an option"
                    :showLabels="false"
                    openDirection="bottom"
                    label="text"
                    track-by="value"
                    @input="onInputFilterDate"
                  >
                    <template slot="singleLabel" slot-scope="props">{{ props.option.text }}</template>
                    <template slot="option" slot-scope="props">{{ props.option.text }}</template>
                  </multiselect> -->
                  <b-form-select v-model="filter.periodBy" :options="filter.periodOptions"></b-form-select>
                </b-input-group-prepend>
                <b-input-group-append>
                  <b-form-datepicker
                    reset-button
                    v-model="filter.periodStart" 
                    :min="filter.minPeriodStart"
                    :max="filter.maxPeriodStart"
                    id="filter-period-start"
                    placeholder="DD/MM/YYYY"
                    :date-format-options="{ year: 'numeric', month: '2-digit', day: '2-digit' }"
                    locale="id"
                    @context="onContextPeriodStart"
                    @input="filterDateTable"
                  ></b-form-datepicker>
                </b-input-group-append>
                <b-input-group-append>
                  <b-input-group-text>
                    ~
                  </b-input-group-text>
                </b-input-group-append>
                <b-input-group-append>
                  <b-form-datepicker
                    reset-button
                    v-model="filter.periodEnd" 
                    :min="filter.minPeriodEnd"
                    :max="filter.maxPeriodEnd"
                    placeholder="DD/MM/YYYY"
                    :date-format-options="{ year: 'numeric', month: '2-digit', day: '2-digit' }"
                    locale="id"
                    @context="onContextPeriodEnd"
                    @input="filterDateTable"
                  ></b-form-datepicker>
                </b-input-group-append>
              </b-input-group>
            </CForm>
          </CCol>
        </CRow>
        <CRow class="mt-2">
          <CCol class="col-xs-12 col-sm-10 col-md-9 col-lg-8 col-xl-7 ml-5">
            <CForm>
              <b-input-group class="custom-input-group-white">
                <b-input-group-prepend class="custom-prepend-middle">
                  <!-- <multiselect 
                    :allow-empty="false"
                    v-model="filter.value" 
                    :options="filter.options"
                    :searchable="false"
                    id="filter-table"
                    placeholder="Select an option"
                    :showLabels="false"
                    openDirection="bottom"
                    label="text"
                    track-by="value"
                  >
                    <template slot="singleLabel" slot-scope="props">{{ props.option.text }}</template>
                    <template slot="option" slot-scope="props">{{ props.option.text }}</template>
                  </multiselect> -->
                  <b-form-select v-model="filter.value" :options="filter.options"></b-form-select>
                </b-input-group-prepend>
                <b-form-input maxlength="50" v-model="filter.filterSearch" autocomplete="off" placeholder="Search"></b-form-input>
                <b-input-group-append>
                  <CButton size="sm" color="primary" type="submit" title="Filter Tabel" :disabled="!table.isLoaded" @click="filterTable">
                    <CIcon name="cil-magnifying-glass" />
                  </CButton>
                </b-input-group-append>
              </b-input-group>
            </CForm>
          </CCol>
        </CRow>
        <CRow class="mt-4">
          <CCol>
            <b-table striped hover show-empty
              responsive="xl"
              :items="table.items"
              :fields="table.fields"
              :busy="!table.isLoaded"
              no-local-sorting no-sort-reset
              @sort-changed="onTableSortChanged"
            >
              <template #cell(receiveNo)="row">
                {{ $helper.showData(row.value, "string") }}
              </template>
              <template #cell(contractNo)="row">
                {{ $helper.showData(row.value, "string") }}
              </template>
              <template #cell(customerName)="row">
                {{ $helper.showData(row.value, "string") }}
              </template>
              <template #cell(notaryCode)="row">
                {{ $helper.showData(row.value, "string") }}
              </template>
              <template #cell(notaryName)="row">
                {{ $helper.showData(row.value, "string") }}
              </template>
              <template #cell(vendorBankAccount)="row">
                {{ $helper.showData(row.value, "string") }}
              </template>
              <template #cell(vendorBank)="row">
                {{ $helper.showData(row.value, "string") }}
              </template>
              <template #cell(invoiceNoNotary)="row">
                {{ $helper.showData(row.value, "string") }}
              </template>
              <template #cell(invoiceNoPnbp)="row">
                {{ $helper.showData(row.value, "string") }}
              </template>
              <template #cell(pnbpFee)="row">
                {{ row.value == 0 ? '-' : $helper.showData(row.value, "number") }}
              </template>
              <template #cell(materai)="row">
                {{ row.value == 0 ? '-' : $helper.showData(row.value, "number") }}
              </template>
              <template #cell(notaryFee)="row">
                {{ row.value == 0 ? '-' : $helper.showData(row.value, "number") }}
              </template>
              <template #cell(paidDateNotary)="row">
                {{ $helper.showData(row.value, "shortDate") }}
              </template>
              <template #cell(paidDatePnbp)="row">
                {{ $helper.showData(row.value, "shortDate") }}
              </template>
              <template slot="empty">
                <div v-if="!table.isLoaded" class="text-center">
                  <b-spinner label="Fetching Data..."></b-spinner>
                </div> 
                <div v-else class="text-center">
                  Tidak ada data
                </div> 
              </template>
            </b-table>
            <CCardFooter>
              <PageSizer :totalRows="table.totalRows" :page="table.currentPage" @limit-change="onTableLimitChange" @page-change="onTablePageChange" />
            </CCardFooter>
          </CCol>
        </CRow>
      </CCardBody>
    </CCard>
    <CRow>
      <CCol class="col-12">
        <b-btn variant="warning" class="float-right btn-sm custom-button-white" title="Download kontrak yang tertampil di tabel" style="width:12rem" :disabled="isDownloading || table.items.length <= 0" @click="downloadContracts">
          <b-spinner small v-if="isDownloading" />
          <span v-else>Download Semua Kontrak</span>
        </b-btn>
      </CCol>
    </CRow>
  </CContainer>
</template>


<script>
export default {
  name: 'InvoicePaidFiduciaList',
  data() {
    const today = this.$moment().format('YYYY-MM-DD')
    return {
      isDownloading: false,
      filter: {
        value: "contractNo",
        options: [
          { value:"contractNo", text: "No. Kontrak" },
          { value:"customerName", text: "Nama Customer" },
          { value:"notaryName", text: "Nama Notaris" },
          { value:"invoiceNoPnbp", text: "Invoice PNBP" },
          { value:"invoiceNoNotary", text: "Invoice Notaris" },
          { value:"receiveNo", text: "Receive No." },
        ],
        filterSearch: '',
        filterType: '',
        filterValue: '',
        periodOptions: [
          { value:"paidDatePnbp", text: "Tanggal Bayar PNBP" },
          { value:"paidDateNotary", text: "Tanggal Bayar Notaris" },
        ],
        periodBy: "paidDatePnbp",
        periodStart: null,
        minPeriodStart: '',
        maxPeriodStart: today,
        periodEnd: null,
        minPeriodEnd: '',
        maxPeriodEnd: today
      },
      table: {
        isLoaded: false,
        // table fields mirrors returned object from server-side
        fields: [
          {key: "receiveNo", label: "Receive No.", sortable: true},
          {key: "contractNo", label: "No. Kontrak", sortable: true},
          {key: "customerName", label: "Nama Customer", sortable: true},
          {key: "notaryCode", label: "Kode Notaris", sortable: true},
          {key: "notaryName", label: "Nama Notaris", sortable: true},
          {key: "vendorBankAccount", label: "Account No.", sortable: true},
          {key: "vendorBank", label: "Bank", sortable: true, class: 'custom-column-invoice-bank'},
          {key: "invoiceNoPnbp", label: "Invoice PNBP", sortable: true},
          {key: "pnbpFee", label: "Biaya PNBP", sortable: true},
          {key: "materai", label: "Biaya Materai", sortable: true},
          {key: "paidDatePnbp", label: "Tanggal Bayar", sortable: true},
          {key: "invoiceNoNotary", label: "Invoice Notaris", sortable: true},
          {key: "notaryFee", label: "Biaya Notaris", sortable: true},
          {key: "paidDateNotary", label: "Tanggal Bayar", sortable: true},
        ],
        items: [],
        sortBy: null,
        sortDesc: true,
        currentPage: 1,
        perPage: 10,
        totalRows: 0,
        totalPages: 0
      }
    }
  },
  methods: {

    onInputFilterDate() {
      if (!this.$helper.isEmpty(this.filter.periodStart) && !this.$helper.isEmpty(this.filter.periodEnd)) {
        this.getTableItems()
      }
    },

    // update datepicker valid dates on change
    onContextPeriodStart() {
      this.filter.minPeriodEnd = this.filter.periodStart
      this.filter.maxPeriodEnd = this.$moment(this.filter.periodStart).add(1, 'years').format('YYYY-MM-DD')
    },
    onContextPeriodEnd() {
      this.filter.maxPeriodStart = this.filter.periodEnd
      this.filter.minPeriodStart = this.$moment(this.filter.periodEnd).subtract(1, 'years').format('YYYY-MM-DD')
    },
    downloadContracts(page = 1) {
      if(isNaN(page)) {
        this.table.currentPage = 1
      }
      else {
        this.table.currentPage = page
      }
      // URL builder
      let getUrl = "/excel/contractPaidFiduciaByte"
      let params = {}
      params['page'] = (this.table.currentPage - 1)
      params['size'] = this.table.perPage
      if(!this.$helper.isEmpty(this.filter.periodBy)){
        params['periodBy'] = this.filter.periodBy
        if(!this.$helper.isEmpty(this.filter.periodStart) && !this.$helper.isEmpty(this.filter.periodEnd)){
          params['periodStart'] = this.filter.periodStart
          params['periodEnd'] = this.filter.periodEnd
        }
      }
      if(!this.$helper.isEmpty(this.filter.filterType) && !this.$helper.isEmpty(this.filter.filterValue)) {
        params['filterType'] = this.filter.filterType
        params['filterValue'] = this.filter.filterValue
      }
      if(this.table.sortBy != null) {
        params['sortBy'] = this.table.sortBy
        params['asc'] = !this.table.sortDesc
      }
      // only send axios request if role is valid
      if(this.$helper.isRole(this.$availRoles['Cabang']) || this.$helper.isRole(this.$availRoles['FIMS']) || this.$helper.isRole(this.$availRoles['HO']) || this.$helper.isRole(this.$availRoles['Notaris'])){
        this.isDownloading = true
        this.$axios.get(getUrl, {
          // necessary to avoid encoding returned bytes
          params: params, 
          responseType: 'blob',
          timeout: 300000
        }).then(response => {
          if(response.status == 200){
            // create file Blob and download according to extension
            let blob=new Blob([response.data], {type: "application/octet-stream"})
            let link=document.createElement('a')
            link.href=window.URL.createObjectURL(blob)
            link.download= "Kontrak_Fiducia_Paid-" + Date.now() + ".xlsx"
            link.click();
          }
          else{
            this.$helper.toastError(this, "Download Kontrak Gagal! " + (!this.$helper.isEmpty(response.data.reason) ? response.data.reason : ""))
          }
        })
        .catch(error => {
          if(!this.$helper.isEmpty(error.response)){
            this.$helper.toastError(this, "Download Kontrak Gagal! " +  (!this.$helper.isEmpty(error.response.data.reason) ? error.response.data.reason : "Endpoint Not Found"))
          }
          else{
            this.$helper.toastError(this, "Download Kontrak Gagal! " + (!this.$helper.isEmpty(error.message) ? error.message : "Network Error"))
          }
        })
        .finally(() => {
          this.isDownloading = false
        })
      }
      else{
        this.$helper.toastError(this, "Access Denied! Mohon tunggu beberapa saat atau lakukan Login ulang")
      }
    },
    // update table with server-side processing on change
    onTableLimitChange(newPerPage) {
      this.table.perPage = newPerPage
      // only fetch data when roles apply
      this.getTableItems()
    },
    onTablePageChange(newPage) {
      // only fetch data when roles apply
      this.getTableItems(newPage)
    },
    onTableSortChanged(ctx) {
      this.table.sortBy = ctx.sortBy
      this.table.sortDesc = ctx.sortDesc
      // only fetch data when roles apply
      this.getTableItems(this.table.currentPage)
    },
    filterDateTable(){
      this.filter.filterType = this.filter.value
      this.filter.filterValue = this.filter.filterSearch
      this.getTableItems()
    },
    filterTable(event){
      event.preventDefault()
      this.filter.filterType = this.filter.value
      this.filter.filterValue = this.filter.filterSearch
      this.getTableItems()
    },
    // get paginated table contents from server-side
    getTableItems(page = 1) {
      // URL builder
      let getUrl = "/payment/getContractPaidFiducia"
      let params = {}
      params['page'] = (page - 1)
      params['size'] = this.table.perPage
      if(!this.$helper.isEmpty(this.filter.periodBy) && !this.$helper.isEmpty(this.filter.periodStart) && !this.$helper.isEmpty(this.filter.periodEnd)){
        params['periodBy'] = this.filter.periodBy
        params['periodStart'] = this.filter.periodStart
        params['periodEnd'] = this.filter.periodEnd
      }
      if(!this.$helper.isEmpty(this.filter.filterType) && !this.$helper.isEmpty(this.filter.filterValue)) {
        params['filterType'] = this.filter.filterType
        params['filterValue'] = this.filter.filterValue
      }
      if(this.table.sortBy != null) {
        params['sortBy'] = this.table.sortBy
        params['asc'] = !this.table.sortDesc
      }
      // only send axios request if role is valid
      if(this.$helper.isRole(this.$availRoles['Cabang']) || this.$helper.isRole(this.$availRoles['FIMS']) || this.$helper.isRole(this.$availRoles['HO']) || this.$helper.isRole(this.$availRoles['Notaris'])){
        this.table.isLoaded = false
        this.$axios.get(getUrl, {params: params}).then(response => {
          if(response.status == 200){
            sessionStorage.setItem("filterInvoicePaidFiduciaPeriodBy", this.filter.periodBy)
            sessionStorage.setItem("filterInvoicePaidFiduciaPeriodStart", this.filter.periodStart)
            sessionStorage.setItem("filterInvoicePaidFiduciaPeriodEnd", this.filter.periodEnd)
            sessionStorage.setItem("filterInvoicePaidFiduciaType", this.filter.filterType)
            sessionStorage.setItem("filterInvoicePaidFiduciaValue", this.filter.filterValue)
            this.table.items = response.data.data.data
            this.table.totalRows = response.data.data.totalElements
            this.table.totalPages = response.data.data.totalPages
          }
          else{
            this.$helper.toastError(this, "Load Daftar Kontrak Gagal! " + (!this.$helper.isEmpty(response.data.reason) ? response.data.reason : ""))
          }
        })
        .catch(error => {
          if(!this.$helper.isEmpty(error.response)){
            this.$helper.toastError(this, "Load Daftar Kontrak Gagal! " +  (!this.$helper.isEmpty(error.response.data.reason) ? error.response.data.reason : "Endpoint Not Found"))
          }
          else{
            this.$helper.toastError(this, "Load Daftar Kontrak Gagal! " + (!this.$helper.isEmpty(error.message) ? error.message : "Network Error"))
          }
        })
        .finally(() => {
          this.table.isLoaded = true
        })
      }
      else{
        this.$helper.toastError(this, "Access Denied! Mohon tunggu beberapa saat atau lakukan Login ulang")
      }
    }
  },
  computed: {
  },
  mounted() {
    if(!this.$helper.isEmpty(sessionStorage.getItem("filterInvoicePaidFiduciaPeriodBy"))){
      this.filter.periodBy = sessionStorage.getItem("filterInvoicePaidFiduciaPeriodBy")
    }
    if(!this.$helper.isEmpty(sessionStorage.getItem("filterInvoicePaidFiduciaPeriodStart"))){
      this.filter.periodStart = sessionStorage.getItem("filterInvoicePaidFiduciaPeriodStart")
    }
    if(!this.$helper.isEmpty(sessionStorage.getItem("filterInvoicePaidFiduciaPeriodEnd"))){
      this.filter.periodEnd = sessionStorage.getItem("filterInvoicePaidFiduciaPeriodEnd")
    }
    if(!this.$helper.isEmpty(sessionStorage.getItem("filterInvoicePaidFiduciaType"))){
      this.filter.filterType = sessionStorage.getItem("filterInvoicePaidFiduciaType")
      this.filter.value = sessionStorage.getItem("filterInvoicePaidFiduciaType")
    }
    if(!this.$helper.isEmpty(sessionStorage.getItem("filterInvoicePaidFiduciaValue"))){
      this.filter.filterValue = sessionStorage.getItem("filterInvoicePaidFiduciaValue")
      this.filter.filterSearch = sessionStorage.getItem("filterInvoicePaidFiduciaValue")
    }
    // get table contents on page load
    this.getTableItems()
  },
  created() {
  }
}
</script>

<style>

</style>
